// extracted by mini-css-extract-plugin
module.exports = {"sideBarDiv":"SideBar_sideBarDiv__7JDMc","closed":"SideBar_closed__2RI9u"};